var r = /* @__PURE__ */ ((o) => (o.Image = "image", o.Json = "json", o.Video = "video", o))(r || {});
export {
  r as AssetType
};
//# sourceMappingURL=url.js.map
